import React from 'react';
import UniversalIconBtn from '../headless/button/UniversalIconBtn';
import styled from 'styled-components';
import { useEditMode } from '../../hooks/useEditMode';
import HeadlessTextArea from '../headless/textarea/HeadlessTextArea';
import { DeviceType, TextAlignment } from '../../enum/EnumRepository';
import { StyledDivComponent, StyledTextAreaComponent } from '../../dto/StyleCompRepository';
import MoleculeDescription from '../molecule/MoleculeDescription';
import { useStandardAlertStore } from '../../store/portal/alertStore';
import searchIcon from '../../../asset/icon/see.png';
import searchNotIcon from '../../../asset/icon/see_not.png';
import { useDeviceStore } from '../../store/deviceStore';
import HintSmallWrapper from '../headless/button/HintSmallWrapper';
import { getHintMessage } from '../../constants/hintMessages';

//isEditMode에 따라 HeadlessTextAread와 바뀌어야 하고
//visible에 따라 보이든 안보이든 해야함
//alignment에 따라 정렬해야함
interface OrgDescriptionProps {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  StyledTextarea: StyledTextAreaComponent;
  StyledDescription: StyledDivComponent;
  alignment?: TextAlignment;
  visible: boolean;
  changeVisible?: () => void;
  changeVisibleMobile?: () => void;
  maxLength?: number;
  maxRows?: number;
}

const OrgDescription: React.FC<OrgDescriptionProps> = ({
  value,
  handleChange,
  StyledTextarea,
  StyledDescription,
  alignment,
  visible,
  changeVisible,
  changeVisibleMobile,
  maxLength,
  maxRows
}) => {
  const { isEditMode } = useEditMode();
  const { deviceType } = useDeviceStore();
  const { setTextLengthExceededAlert } = useStandardAlertStore();

  const handleChangeWithLimit = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      setTextLengthExceededAlert(maxLength);
      return;
    }
    handleChange(e);
  }

  return (
    <>
      {isEditMode ? (
        <OrgWrapper>
          {maxLength && (
            <LimitDiv>
              {value.toString().length} / {maxLength}
            </LimitDiv>
          )}
          <TextAreaWrapper $isVisible={visible}>
            <HeadlessTextArea
              alignment={alignment ? alignment : TextAlignment.LEFT}
              content={value}
              placeholder="Enter description"
              handleChange={maxLength ? handleChangeWithLimit : handleChange}
              StyledTextArea={StyledTextarea}
              $maxRows={maxRows}
            />
          </TextAreaWrapper>
          {changeVisible && (
            <HintSmallWrapper content={visible ? getHintMessage('SET_TO_PRIVATE') : getHintMessage('SET_TO_PUBLIC')} toLeft={true}>
              <UniversalIconBtn
                size="fit"
                border={false}
                isTransparent
                backgroundImg={visible ? searchIcon : searchNotIcon}
                onClick={deviceType === DeviceType.MOBILE ? changeVisibleMobile : changeVisible}
              />
            </HintSmallWrapper>
          )}
        </OrgWrapper>
      ) : (
        visible ?
          <MoleculeDescription
            value={value}
            StyledDescription={StyledDescription}
            alignment={alignment ? alignment : TextAlignment.LEFT}
          />
          :
          null
      )}
    </>
  );
};

export const OrgWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextAreaWrapper = styled.div <{ $isVisible: boolean }>`
  width: 100%;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0.5)};
`;

const LimitDiv = styled.div`
  position: absolute;
  top: 0;
  right: calc(16px + clamp(14px, 2vw, 16px));
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  z-index: 2;
`;

export default OrgDescription;
